import React from "react";
import PageTitle from "../../Common/PageTitle";
import StatusTags from "../../Tags/StatusTags";
import Divider from "../../Common/Divider";

const OverviewCard = ({ title = "title", RightSection, children }) => {
  return (
    <div className="inputShadow p-3 flex flex-col gap-6 rounded-lg h-full">
      <div className="flex justify-between items-center">
        <PageTitle title={title} tag="h6" />
        {RightSection && <div className="flex gap-2">{RightSection}</div>}
      </div>
      {children}
    </div>
  );
};
export const InnerCard = ({
  title,
  status,
  number,
  firstLabel,
  firstValue,
  secondLabel,
  secondValue,
  daysLeft,
  getDaysColor,
}) => {
  return (
    <div className="border border-gray-200 rounded-lg p-3 bg-[#F9F9F9] shadow-lg flex flex-col gap-2 ">
      {/* Header Row */}
      <div className="flex justify-between items-center">
        <div className="flex gap-3">
          <span>{title}</span>
          {number && (
            <>
              <span className="body-two text-xs text-gray-500 mt-0.5">:</span>
              <span className="card-title font-medium text-black ">
                {number}
              </span>
            </>
          )}
        </div>
        {status && (
          <StatusTags
            tag={status}
            color={
              status === "Active"
                ? "success"
                : status === "Expiring Soon"
                  ? "warning"
                  : "danger"
            }
          />
        )}
      </div>

      {/* Info Row */}
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-2 text-sm text-red info-text-header-meadium ">
          {firstLabel && firstValue && (
            <span className="text-black font-[500]">
              {firstLabel}: {firstValue}
            </span>
          )}

          {/* Only show divider if both exist */}
          {firstLabel && firstValue && secondLabel && secondValue && (
            <Divider orientation="vertical" />
          )}

          {secondLabel && secondValue && (
            <span className="text-black font-[500]">
              {secondLabel}: {secondValue}
            </span>
          )}
        </div>

        {daysLeft && (
          <span className={`text-sm font-medium text-${getDaysColor}-500`}>
            {daysLeft}
          </span>
        )}
      </div>
    </div>
  );
};

export default OverviewCard;
